import { createTRPCReact, httpBatchLink, loggerLink } from '@trpc/react-query';
import { QueryClient } from '@tanstack/react-query';
import superjson from 'superjson';
import type { AppRouter } from '@scope/trpc';
import { env } from '../env.js';
import { supabase } from './supabase.js';
import { getPreviewContactId } from './preview.js';

/**
 * Typed tRPC React client. All agency + portal screens use `trpc.<router>.<procedure>.useQuery/useMutation`.
 */
export const trpc = createTRPCReact<AppRouter>();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export const trpcClient = trpc.createClient({
  links: [
    loggerLink({ enabled: () => env.MODE === 'development' }),
    httpBatchLink({
      url: `${env.VITE_API_URL}/trpc`,
      transformer: superjson,
      async headers() {
        const {
          data: { session },
        } = await supabase.auth.getSession();
        const h: Record<string, string> = {};
        if (session?.access_token) h.authorization = `Bearer ${session.access_token}`;
        const previewId = getPreviewContactId();
        if (previewId) h['x-scope-preview-as-contact-id'] = previewId;
        return h;
      },
    }),
  ],
});
